export async function downloadPreparedFile(tg, prepared, fallbackName = 'report.xlsx') {
  const downloadUrl = prepared?.downloadUrl;
  const fileName = prepared?.fileName || fallbackName;
  if (!downloadUrl) throw new Error('Сервер не вернул ссылку на файл');

  if (typeof tg?.downloadFile === 'function') {
    const accepted = await new Promise((resolve, reject) => {
      try {
        tg.downloadFile(
          { url: downloadUrl, file_name: fileName },
          (isAccepted) => resolve(Boolean(isAccepted))
        );
      } catch (error) {
        reject(error);
      }
    });
    if (!accepted) throw new Error('Скачивание отменено');
    return { fileName, method: 'telegram' };
  }

  if (typeof tg?.openLink === 'function') {
    tg.openLink(downloadUrl);
    return { fileName, method: 'browser' };
  }

  const link = document.createElement('a');
  link.href = downloadUrl;
  link.download = fileName;
  link.target = '_blank';
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  link.remove();
  return { fileName, method: 'link' };
}
